import React from "react"

interface LevelProps {
  level: string
  label: string
  xPosition: number
  width: number
}

const Level = ({ level, label, xPosition, width }: LevelProps): React.JSX.Element => {

  return (
    <>
      <g>
        <rect
          id={level}
          className="droppable-target"
          x={xPosition}
          y="0"
          width={width}
          height="470"
          fill="white"
          stroke="silver"
          strokeWidth="1"
          rx="6"
          ry="6"
        ></rect>
        <text fill="black" x={xPosition + (width / 2)} y="30" textAnchor="middle" dominantBaseline="middle" style={{ fontSize: 16 }}>
          {label}
        </text>
        <line x1={xPosition + 1} x2={xPosition + width - 1} y1="60" y2="60" stroke="#E5E5E5" strokeWidth="1"></line>
      </g>
      <g key={`${level}-rect-shadow`}>
        <rect id={`${level}-rect-shadow`} x={xPosition + 1} y="61" width={width - 2} height="150" fill="rgba(245, 245, 245, 0.9)" />
      </g>
    </>
  )
}


export default Level
